jQuery(document).ready(function($) { 


  //  HOME, ON ACTIVE LE MENU //
  if($('body').hasClass('home')){


  var $close_lightbox = $('.js-CloseLightBox');
  var $lightbox_home = $('.HomeLightobx');


      $close_lightbox.click(function () {
           $( ".HomeOverlay" ).fadeOut(500);
           $lightbox_home.fadeOut(500, function(){
             $('body').removeClass('LightBoxOpen');
              $( ".menu-toggle" ).trigger( "click" );
           });

           
           // window.location.hash = '';
            return false;
        });

}


  // MENU TOGLE // SUB MENU
  $("#primary-menu ul.sub-menu").hide();    
  
  $("#primary-menu > li > a").each( function () {
        $(this).replaceWith('<a href="" title="Afficher le sous-menu">' + $(this).text() + '<\/a>') ;
    } ) ;


  /// On modifie l'évènement "click" sur les liens dans les items de liste
    // qui portent la classe "toggleSubMenu" :
    $("#primary-menu > li > a").click( function () {
        // Si le sous-menu était déjà ouvert, on le referme :
        if ($(this).next("ul.sub-menu:visible").length != 0) {
            $(this).next("ul.sub-menu").slideUp("normal");
            $(this).parent().removeClass("open");
        }
        // Si le sous-menu est caché, on ferme les autres et on l'affiche :
        else {
            $("#primary-menu ul.sub-menu").parent().removeClass('open');
            $("#primary-menu ul.sub-menu").slideUp("normal");
            $(this).next("ul.sub-menu").slideDown("normal");
            $(this).parent().addClass("open");
        }
        // On empêche le navigateur de suivre le lien :
        return false;
    });  


    $("#primary-menu .sub-menu a,.MenuFooter a").click( function () {
        
        var page = $(this).attr('href'); // Page cible
        var hash = page.substring(page.indexOf("#")+1);
        if ($( "#"+hash).length && hash.length > 0) {

          var position_to_go = $("#"+hash).offset().top;

            var speed = 450; // Durée de l'animation (en ms)
            if($("#site-navigation").hasClass('toggled')){  
              $( ".menu-toggle" ).trigger( "click" );
             }
            $('html, body').animate( { scrollTop: position_to_go }, speed ); // Go
            return false;
      }
         //return false;
    });



  
//  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
  // WOW EFFECT //



  // GALERIE IMAGES //

     var gallery_single = $("#Gallery-Single");

   if ( $( gallery_single).length ) {

       gallery_single.owlCarousel({
       loop:true,
       thumbs: true,
       thumbsPrerendered: true,
       autoplaySpeed:500,
       navSpeed:500,
       smartSpeed:500,
       fluidSpeed:500,
       margin:0,
       nav:false,
       items:1,
       dots:true,
       mouseDrag:false,
       touchDrag:true,
       // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
    });

  }

  var EtapesChantier_Step_js = $('.EtapesChantier-Step--js');
 
  if ( $(EtapesChantier_Step_js).length ) {
     var top_parent = $('.EtapesChantier').offset().top;

    var top_last_avancement = $('.EtapesChantier-Single-js-On').last().offset().top + $('.EtapesChantier-Single-js-On').last().height() + parseInt($('.EtapesChantier-Single-js-On').last().next().height()/2);
    EtapesChantier_Step_js.css('height', parseInt(top_last_avancement - top_parent));
  }








    // ACTUALITES // Loader en ajax au dessus //

  theme_load_portfolio_content();

      function theme_load_portfolio_content() {
          var slideToSpeed = 500;
          var slideUpSpeed = 700;
          var $easingType = 'easeOutQuart';
          var $close_button = $('#close');
          var $load_items = $('a.load-ajax-content');
          var hash = window.location.hash.substr(1);
          $('a').each(function () {
              var $this = $(this);
              var rel = $this.attr('rel');
              var href = $this.attr('href');
              if (hash == rel) {
                 // console.log($("#Top_page")[0].scrollHeight);

                  $('html,body').animate({ scrollTop: $("#Top_page").offset().top-50},600,'swing',function(){
                      loadContent(href);
                  }
                );


              }
          });

         $( "body" ).on( "click", ".PostArchive-Resume", function(event) {

          var link = $(this).find('a.load-ajax-content');

            $(".resume_art").removeClass('active');
            $(this).addClass('active');
            var $this = link;
            var rel = $this.attr('rel');
            var href = $this.attr('href');
          
            if (window.location.hash.substr(1) == rel) {
                 // console.log($("#Top_page").offset().top);
               
                $('html,body').animate({ scrollTop: $("#Top_page").offset().top-50},600,'swing');

            } else {
                window.location.hash = rel;
                  // console.log($("#Top_page").offset().top);
                
                $('html,body').animate({ scrollTop: $("#Top_page").offset().top-50},600,'swing',function(){
                       $close_button.fadeOut(100);
                        $('#page-ajax-content').slideUp(slideUpSpeed, function () {
                            loadContent(href);
                        });
                    }

                  );

            }
            return false;
        });
        $close_button.click(function () {

            $load_items.removeClass('active');
            $close_button.fadeOut(500);
           
            $('#page-ajax-content').slideUp();
           
           // window.location.hash = '';
            return false;
        });

        function loadContent(href) {
            $('#loader').fadeIn(100);
            var LoadContentWrapper = href + ' .pageloader-inner'; // contenu de la page chargé //

            $('#pageloader').delay(500).queue(function () {

                $(this).load(LoadContentWrapper, function () {
                
                    $('#loader').fadeOut(100);
                    $('#page-ajax-content').slideDown(slideUpSpeed, function () {
                        $close_button.fadeIn(500);
                    });
                  //  theme_gallery();
                  // theme_remove_image_preload();
                  //  theme_image_hover('#page-ajax-content');
                  //  theme_fancybox();
                  //  theme_media_player();
                });
               // $(this).dequeue();
                $(this).clearQueue();
            });
        }
    }



    //  $( ".PostArchive-Resume" ).click(function(event) {
    //   document.location = $(this).find('a').attr('href');
    // }); 

     ///////// OOOOOOFRE EMPLOI /////////

     if($('body').hasClass('page-template-modele_rejoignez_nous')){
      theme_load_offre_in_table();
    }
     
      var $precedente_offre_ouverte = '';


      function theme_load_offre_in_table() {
          var slideToSpeed = 500;
          var slideUpSpeed = 700;
          var $easingType = 'easeOutQuart';
          var $close_button = $('#close');
          var $load_items = $('a.load-ajax-content-offre');
          var hash = window.location.hash.substr(1);
          $('a').each(function () {
              var $this = $(this);
              var rel = $this.attr('rel');
              var href = $this.attr('href');
              if (hash == rel) {
                 console.log(rel);
                  
                 loadContent_offre(rel,href);
                    
               


              }
          });

      

         $( "body" ).on( "click", "a.load-ajax-content-offre", function() {
            $load_items.removeClass('active');
            $(this).addClass('active');

            $id_offre = $(this).attr('data-id-offre');
            console.log($id_offre);

            var $this = $(this);
            var rel = $this.attr('rel');
            var href = $this.attr('href');
         
            if (window.location.hash.substr(1) == rel) {
                 // console.log($("#actualites").offset().top);
               
                // TweenMax.to( $('html,body'), 0.5, {scrollTop: $('#single-offre-'+$id_offre).offset().top-190,ease:Power4.easeOut});

            } else {
                window.location.hash = rel;
   
                       //$close_button.fadeOut(100);
                      
                       if ($precedente_offre_ouverte != ''){
                          var $quel_div = $('#single-offre-'+$precedente_offre_ouverte+' > td > div');
                         $quel_div.slideUp(slideUpSpeed, function () {
                            $quel_div.remove();
                            loadContent_offre($id_offre,href);
                        });
                       }else{
                         loadContent_offre($id_offre,href);
                       }
                       
                    }

                  

            
            return false;
        });
        $close_button.click(function () {

            $load_items.removeClass('active');
            $close_button.fadeOut(500);
           
            $('#page-ajax-content').slideUp();
           
            //window.location.hash = '';
            return false;
        });

        function loadContent_offre(id_offre, href) {
            // $('#loader').fadeIn(100);
            $('#single-offre-'+id_offre+' td').addClass('loader');
            $('html,body').animate({ scrollTop: $('#single-offre-'+id_offre).offset().top-190},600,'swing',function(){
                
            var LoadContent_offreWrapper = href + ' .pageloader-inner'; // contenu de la page chargé //

            $('#single-offre-'+id_offre+' td').delay(500).queue(function () {

                $(this).load(LoadContent_offreWrapper, function () {
                  
                  $('#single-offre-'+id_offre+' td').removeClass('loader');

                  $precedente_offre_ouverte =  id_offre;
                   // $('#loader').fadeOut(100);
                   $('.pageloader-inner').slideDown(slideUpSpeed, function () {
                        $close_button.fadeIn(500);
                    });
                  
                });
               // $(this).dequeue();
                $(this).clearQueue();
            });
        }); // fin complete tweenamx
    
      } // fin load content //
    }

    // fin chargement offre //














}); // fin ready menu